export default {
  SELECT_YOUR_VEHICLE: 'Select Your Bike',
  ADD_VEHICLE: 'Add a bike',
  VERIFY_FITMENT_TITLE: 'Verify fitment with your bike:',
  GET_PRODUCTS_FOR_VEHICLE: 'Get products for your bike',
  STORE_VEHICLE_IN_GARAGE: 'Store your bike in the garage',

  PRODUCT_ITEM_CLASS: `product-item product-item--vertical 1/3--tablet-and-up 1/4--desk`,
};
